<div class="layout-wrapper">
    <app-client-header></app-client-header>

    <app-kyc-banner></app-kyc-banner>

    <!--
        Two shells share one scroll container and one outlet, so switching nav
        (supers only) never remounts the page:
        - legacy: Bootstrap container (container-fluid while collapsed)
        - new nav (RF-2798/RF-2869): the design's full-width shell
    -->
    <div
        class="content-wrapper"
        scrollTopOnNavigate
        [class.ds-shell]="pageSidebarService.newNavActive()"
        [class.py-4]="!pageSidebarService.newNavActive()"
        [class.container-fluid]="
            !pageSidebarService.newNavActive() &&
            pageSidebarService.fullscreen()
        "
        [class.container]="
            !pageSidebarService.newNavActive() &&
            !pageSidebarService.fullscreen()
        "
    >
        <div
            class="d-flex"
            [class.ds-shell-row]="pageSidebarService.newNavActive()"
        >
            @if (pageSidebarService.newNavActive()) {
                <aside class="ds-shell-sidebar d-none d-md-block">
                    <app-client-sidebar></app-client-sidebar>
                </aside>
            } @else {
                <!-- Sticky Sidebar -->
                <aside
                    class="sidebar-sticky d-none d-md-block"
                    [style.width]="pageSidebarService.sidenavWidth()"
                    [style.flex-shrink]="'0'"
                >
                    <page-sidebar-menu></page-sidebar-menu>
                </aside>
            }

            <!-- Main content area -->
            <main
                class="main-content flex-fill"
                [class.ds-shell-main]="pageSidebarService.newNavActive()"
                [style.margin-left]="
                    pageSidebarService.newNavActive()
                        ? null
                        : pageSidebarService.collapsed()
                          ? '20px'
                          : '20px'
                "
            >
                <router-outlet></router-outlet>
            </main>
        </div>
    </div>
</div>
